import React from 'react'
import { TablaEditarGrupos,TablaEditarPromotorias } from '../../Components/Components'

export const MisGrupos = ({initState,updateState,data,reload}) => {
  return (
    <React.Fragment>
      <TablaEditarGrupos initState={initState} updateState={updateState} data={data} reload={reload} />
      {/* <TablaEditarPromotorias initState={initState} updateState={updateState} /> */}
    </React.Fragment>
  )
}
